@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

/* === Tab wrapper === */

.shipping-tab {
  padding: @space-0 @space-16 @space-16;
}

/* === Main content card (Preset + Shipping preferences + Location & dimensions) === */

.content-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
}

/* === Preset row === */

.preset-row {
  padding: @space-12 @space-16;
}

.preset-row > span {
  display: block;
  font-weight: 500;
  padding-bottom: @space-4;
}

.preset-row > :last-child {
  width: calc((100% - @space-8 * 2) / 3);
}

.preset-row > :last-child button {
  width: 100%;
}

/* === BYOL === */

.byol-banner {
  width: calc(100% - 40px);
  margin: @space-8 @space-20;
}

/* === Section layout === */

.section {
  padding: @space-4 @space-16 @space-16;
}

/* === Shipping options 3-column grid with labels === */

.shipping-options {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: @space-8;
  padding: @space-8 @space-0;
}

.shipping-option-label {
  padding: @space-8 @space-0 @space-4;
  font-weight: 500;
}

/* === Packaging options (unchanged) === */

.packaging-options-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: @space-8;
  margin-bottom: @space-12;
}

.packaging-label {
  font-weight: 500;
  padding: 0 @space-12 @space-8;
}

.packaging-dropdown-wrapper {
  padding: @space-0 @space-12 @space-0;
}

/* === Section title (outside cards) === */

.section-title {
  padding: @space-12 @space-0 @space-8;
}

/* === Dimensions side-by-side cards === */

.dimensions-row {
  flex-wrap: nowrap;
  align-items: stretch;
}

.dimensions-card {
  flex: 0 0 calc(50% - @space-12 / 2);
  min-width: 0;
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
  padding: @space-12 @space-16;
}

/* === Location 2-column grid === */

.location-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: @space-4 @space-16;
  padding: @space-8 @space-0;
}

/* === Labels === */

.label {
  padding: @space-4 @space-0;
  font-weight: 500;
}

/* === Weight and dimension inputs === */

.weight-wrapper {
  padding-bottom: @space-4;
}

.weight-wrapper > div > div {
  gap: @space-16;
}

.weight-input {
  height: 22px;
  padding: @space-4 @space-8;
  border: 1px solid @product-page--input--border-color;
}

.weight-input:focus-within {
  border-color: @product-page--input--focus--border-color;
}

.input-wrapper Input {
  border: 1px solid @product-page--input--border-color;
}

.input-wrapper Input:focus-within {
  border-color: @product-page--input--focus--border-color;
}

.size-wrapper {
  padding-bottom: @space-4;
}

.size-wrapper > div > div {
  gap: @space-16;
}

.size-input {
  height: 22px;
  padding: @space-4 @space-8;
  border: 1px solid @product-page--input--border-color;
}

.size-input:focus-within {
  border-color: @product-page--input--focus--border-color;
}

/* === Toggle card (bordered container for collapsible toggles) === */

.toggle-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
  padding: @space-12 @space-16;
  margin-top: @space-12;
}

.toggle-with-caption {
  padding-top: @space-4;
}

.caption {
  padding-left: @space-36;
  padding-top: @space-4;
  color: var(--grey-900);
}

/* === Expanded content (below toggle) === */

.expanded-content {
  padding-left: @space-36;
  padding-top: @space-8;
}

/* === Product fee (inline under toggle) === */

.product-fee-input {
  padding-top: @space-4;
  width: 184px;
}

.product-fee-input input {
  height: 32px;
  padding: @space-4 @space-8;
}

/* === V3-only overrides for shared components (must not touch shared files) === */

/* Remove left padding from options-dropdown-wrapper (shared style.less) in V3 shipping grid */
.shipping-options :global([class*='options-dropdown-wrapper']) {
  padding-left: 0;
}

/* 24px column gap for DangerousGoodsForm grid inside V3 toggle card */
.expanded-content :global([class*='grid-container']) {
  column-gap: @space-24;
}
